import { render } from "./EmailChangeModal.vue?vue&type=template&id=27d738d6"
import script from "./EmailChangeModal.vue?vue&type=script&lang=js"
export * from "./EmailChangeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__